export const ledvance = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 15,
  inputPaddingInline: 10,

  inputHeight: 46,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 14,
  inputFontFamily: '"Helvetica Neue", sans-serif',
  inputColor: "#727271",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 400,

  inputBorderColor: "#707070",
  inputBorderWidth: 1,
  inputBorderRadius: 2,

  inputHoverColor: "#727271",
  inputHoverBorderColor: "#707070",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 15,
  selectPaddingInline: 10,

  selectHeight: 46,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 14,
  selectFontFamily: '"Helvetica Neue", sans-serif',
  selectColor: "#727271",
  selectBackgroundColor: "#F0F0F0",
  selectFontWeight: 400,

  selectBorderColor: "#ffffff",
  selectBorderWidth: 1,
  selectBorderRadius: 2,

  selectHoverColor: "#727271",
  selectHoverBorderColor: "#707070",
  selectHoverBackgroundColor: "#F0F0F0",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 15,
  textAreaPaddingInline: 10,

  textAreaHeight: 183,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 14,
  textAreaFontFamily: '"Helvetica Neue", sans-serif',
  textAreaColor: "#727271",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 400,

  textAreaBorderColor: "#707070",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 0,

  textAreaHoverColor: "#727271",
  textAreaHoverBorderColor: "#707070",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#D3D3D3",
  placeholderFontFamily: '"Helvetica Neue", sans-serif',
  placeholderFontSize: 14,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#D3D3D3",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 6,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 17,
  fieldLabelColor: "#666666",
  fieldLabelFontWeight: 700,
  fieldLabelColorAsterisk: "#666666",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Helvetica Neue", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#666666",
  descriptionFontSize: 12,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Helvetica Neue", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 11,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 0,
  checkboxUncheckedBorderColor: "#707070",
  checkboxUncheckedBackgroundColor: "#ffffff",
  checkboxCheckedBackgroundColor: "#FF6600",
  checkboxCheckedBorderColor: "#707070",
  checkboxCheckedColor: "#ffffff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Helvetica Neue", sans-serif',
  checkboxLabelFontSize: 14,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#666666",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 11,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#707070",
  radioUncheckedBackgroundColor: "#ffffff",
  radioCheckedBackgroundColor: "#FF6600",
  radioCheckedBorderColor: "#707070",

  radioAlignment: "none",

  radioLabelFontFamily: '"Helvetica Neue", sans-serif',
  radioLabelFontSize: 14,
  radioLabelFontWeight: 400,
  radioLabelColor: "#666666",

  // **********************************
  // submit button

  submitMarginTop: 44,
  submitFontSize: 16,
  submitFontFamily: "'Montserrat', sans-serif",
  submitWidth: 212,
  submitWidthUnits: "px",
  submitHeight: 56,
  submitBorderRadius: 35,
  submitBorderWidth: 1,
  submitBackground: "#FF6600",
  submitColor: "#ffffff",
  submitBorderColor: "#FF6600",
  submitBackgroundHover: "#FF6600",
  submitBorderColorHover: "#FF6600",
  submitColorHover: "#ffffff",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 500,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "left",
};

  